import {inject, singleton} from "tsyringe";
import {CommandHandler} from "../../decorators/command-handler.decorator";
import {appState} from "../../app.state";
import {FiltersDTO} from "../../domain/dtos/filters.dto";
import {ClearFiltersCommand} from "../clear-filters.command";
import {ICommand} from "../i-command.interface";
import {ICommandHandler} from "./i-command.handler";

@CommandHandler(ClearFiltersCommand)
@singleton()
export class ClearFiltersCommandHandler implements ICommandHandler<void> {
    
    public async handle(command: ICommand<void>): Promise<void> {
        // Filters zurücksetzen - NICHT ans Backend senden!
        appState.filters = {} as FiltersDTO;
    }
}